import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/types'
import type { FetchOptions } from '../../loaris-trojan-remover.service'
import {
  VirusSummaryCardsService,
  VirusSummaryRes,
} from './virus-summary-cards.service'


export default /*#__PURE__*/_defineComponent({
  __name: 'virus-summary-cards',
  emits: ["openTerminalDrawer", "openRiskDrawer"],
  setup(__props, { emit: __emit }) {

const injector = useReflectiveInjector([VirusSummaryCardsService])
const service = injector.get(VirusSummaryCardsService)
const { t } = useI18n()

const emit = __emit

const isLoading = ref(false)
const summaryData = ref<VirusSummaryRes>({
  virus_risk_device_count: 0,
  untreated_virus_count: 0,
  quarantine_file_count: 0,
  trusted_file_count: 0,
})

const cardItems = computed<StatisticsCardItem[]>(() => {
  const s = summaryData.value
  const trusted = s.trusted_file_count ?? 0
  return [
    {
      label: t('safeProtectionModule.virusRiskTerminal'),
      value: s.virus_risk_device_count,
      clickable: (s.virus_risk_device_count ?? 0) > 0,
    },
    {
      label: t('safeProtectionModule.unhandledVirus'),
      value: s.untreated_virus_count,
      clickable: (s.untreated_virus_count ?? 0) > 0,
    },
    {
      label: t('safeProtectionModule.quarantineFiles'),
      value: s.quarantine_file_count,
      clickable: (s.quarantine_file_count ?? 0) > 0,
    },
    {
      label: t('safeProtectionModule.trustedFiles'),
      value: trusted,
      clickable: false,
      /** 第 4 项：在 item.events 上执行点击（已信任 → 风险列表 handle_status=4） */
      events: {
        click: () => {
          if (trusted <= 0) return
          emit('openRiskDrawer', 4)
        },
      },
    },
  ]
})

function onStatCardItemClick (index: number) {
  const s = summaryData.value
  if (index === 0) {
    if ((s.virus_risk_device_count ?? 0) <= 0) return
    emit('openTerminalDrawer', { range: 1 })
    return
  }
  if (index === 1) {
    if ((s.untreated_virus_count ?? 0) <= 0) return
    emit('openRiskDrawer', 1)
    return
  }
  if (index === 2) {
    if ((s.quarantine_file_count ?? 0) <= 0) return
    emit('openRiskDrawer', 2)
  }
}

function loadData () {
  isLoading.value = true
  service.getVirusSummary().then((res) => {
    summaryData.value = res
  }).finally(() => {
    isLoading.value = false
  })
}

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(StatisticsCards, {
    items: cardItems.value,
    onItemClick: onStatCardItemClick
  }, null, 8, ["items"])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})